<div class="container__filter" (click)="closedSearch()">
  <!-- BUSCA SUPERIOR -->
  <div class="dnd-filter">
    <div class='dnd-element'>
      <div class="dnd-itens-filter">
        <app-autocomplete placeholder="Editar"
        inputId="distribution-broker-search-1"
        placeholder="Busca"
        maxLength="200"
        [autoSearchResults]="options" 
        [onlyDescription]="!featureInputSearch"
        (ElementSelected)="elementSelected($event)"
        (autocompleteSearch)="searchElement($event)"
        value="description"
        [enhanveOnHover]="false">
        </app-autocomplete>
      </div>
      <div class="dnd-itens-filter dnd-itens--flex">
        <button id="dnd-filter-btn" class="btn-filter rounded__border" (click)="handleModal()">
          <img src="../../assets/svgs/funnel.svg" alt="Funnel Inativo" *ngIf="!hasFilter">
          <img src="../../assets/svgs/funnel_act.svg" alt="Funnel Ativo" *ngIf="hasFilter">
        </button>
        <img class="dnd-dot-alert" src="../../assets/svgs/dot-alert.svg" alt="Alert" *ngIf="validator()">
        <button 
          class="btn-options"
          *ngIf="hasBtnAction()"
          id="btn-acoes"
          [ngClass]="{'open-modal': rowDown}"
          [matMenuTriggerFor]="beforeMenu"
          (click)="rowDown = !rowDown">
          <span class="btn-text">Ações</span>
          <img src="../../assets/svgs/arrow_down.svg" alt="Icon">
        </button>
        <mat-menu #beforeMenu="matMenu" xPosition="after">
          <button mat-menu-item (click)="selectAction(1)">Redistribuir leads</button>
        </mat-menu>
        <app-filter-impounded-leads *ngIf="showImpoundedFilter" (closeModal)="closeImpoundedFilter()"></app-filter-impounded-leads>
      </div>
    </div>
    <div class="tags-list">
      <app-content-scrollable>
        <ul #childComponent class="tags-container" class="enable-swipe" *ngIf="propsFilter.length">
          <app-tags [id]="'tag-chip-' + a" (remove)="removeTag(tag)" class="tag" *ngFor="let tag of tags; let a = index">
            {{ tag.value }}
          </app-tags>
        </ul>
      </app-content-scrollable>
    </div>
  </div>

  <!-- Add filter here! -->
  <app-filter-leads (closeModal)="handleModal()" (emitFilter)="applyFilter()" [formGroup]="form" *ngIf="showFilter" (resetClick)="clear()"></app-filter-leads>

</div>
<p class="impounded__title" *ngIf="!propsFilter.length">Leads represados</p>
<div class="custom__table__leads">
  <table class="rounded__border table__border scroll__customized">
    <div class="table__content--full-width">
      <tr class="header">
        <th *ngFor="let column of headers; let i = index"
        [ngStyle]="{'min-width': column.style.width, 'width': column.style.width}">
        <div>
          <lib-input-checkbox *ngIf="column.hasCheckbox" class="input-control" [attr.id]="'selectAll' + i" name="selectAll" [(ngModel)]="isSelect" (click)="selectAll()"></lib-input-checkbox>
          <app-arrow-label *ngIf="column.sort" (sort)="sort($event, column)" label="column.label">
            <span>{{column.label}}</span>
          </app-arrow-label>
          <span *ngIf="!column.sort && !column.hasCheckbox">{{column.label}}</span>
        </div>
        </th>
      </tr>
      <div style="width: 100%;">
        <tbody class="body">
          <tr *ngFor="let bodyItem of data; let i = index">
            <td [ngStyle]="{'min-width': column.style.width, 'width': column.style.width}"
              (click)="column.onClick && column.onClick(bodyItem, bodyItem[column.id])"
              *ngFor="let column of headers; let i = index">
              <lib-input-checkbox *ngIf="column.hasCheckbox" class="input-control" [attr.id]="'selectItem' + i" name="selectItem" [(ngModel)]="bodyItem[column.id]" (click)="onSelect()"></lib-input-checkbox>
              <app-contact-component [attr.id]="'contactItem' + i" [item]="bodyItem[column.id]" *ngIf="column.contact"></app-contact-component>
              <span [attr.id]="'tbodyItem' + i" *ngIf="!column.contact && !column.hasCheckbox">
                {{bodyItem[column.id]}}
              </span>
            </td>
          </tr>
        </tbody>
      </div>
    </div>
  </table>
</div>